<template>
    <div>
        <div class="box box-primary">
            <div class="box-header with-border">
                <h3 class="box-title">Filter</h3>
                <div class="box-tools pull-right">
                    <button
                        class="btn btn-box-tool"
                        title="Collapse"
                        type="button"
                        @click="toggleCollapse('filter')"
                    >
                        <i
                            :class="[getCollapseStatus('filter') ? 'fa-minus' : 'fa-plus']"
                            class="fa"
                        ></i>
                    </button>
                </div>
            </div>
            <vue-slide-up-down
                :active="getCollapseStatus('filter')"
                :duration="durationCollapse"
            >
                <div class="box-body">
                    <div class="box-body-tab">
                        <multi-select-component
                            id="filter"
                            ref="filterRef"
                            :searchable="true"
                            :disabled="sending"
                            :items="itemsFilter"
                            :selected="getExternalParam('filter')"
                            placeholder="Select or leave empty"
                            class-main-block="form-group col-lg-4 col-md-6 col-xs-12"
                            title="Filters"
                            @change="changeFilter"
                        />
                        <template v-for="value in itemsFilterSelected">
                            <multi-select-component
                                v-if="existFilter"
                                :id="value.id"
                                :key="value.id"
                                ref="formItemsDynamicRef"
                                :class-main-block="value.classMainBlock"
                                :class-select="value.classSelect"
                                :disabled="sending || disabledDynamicFilter"
                                :max="value.max"
                                :items="getItems(value.id)"
                                :route="value.route"
                                :selected="getExternalParam(value.id)"
                                :title="value.name"
                                placeholder="Select or leave empty"
                                @change="callMethod(value.change)"
                                @setItems="setItems"
                            />
                        </template>
                        <checkbox-component
                            v-if="itemsFilterSelected.length > 0"
                            id="onlyActive"
                            ref="onlyActiveRef"
                            :selected="onlyActive"
                            :disabled="sending"
                            class-main-block="form-group col-lg-2 col-md-6 col-xs-12"
                            title="Only Active"
                            @change="changeOnlyActive"
                        />
                        <div class="form-group col-xs-12">
                            <label class="col-xs-12 hidden-xs hidden-lg"></label>
                            <button
                                :disabled="sending"
                                class="btn btn-sm btn-primary"
                                type="button"
                                @click="getReport()"
                            >
                                Apply
                            </button>
                            <button
                                :disabled="sending"
                                class="btn btn-sm btn-info"
                                type="button"
                                @click="clearFilter()"
                            >
                                Clear
                            </button>
                            <div class="delimiter-button"></div>
                            <button
                                :disabled="sending"
                                class="btn btn-sm bg-yellow"
                                type="button"
                                @click="getReport(true)"
                            >
                                Export
                            </button>
                        </div>
                    </div>
                </div>
            </vue-slide-up-down>
        </div>
        <div class="box box-primary">
            <div class="box-header with-border">
                <h3 class="box-title">Report</h3>
                <div class="box-tools pull-right">
                    <button
                        class="btn btn-box-tool"
                        title="Collapse"
                        type="button"
                        @click="toggleCollapse('report')"
                    >
                        <i
                            :class="[getCollapseStatus('report') ? 'fa-minus' : 'fa-plus']"
                            class="fa"
                        ></i>
                    </button>
                </div>
            </div>
            <vue-slide-up-down
                :active="getCollapseStatus('report')"
                :duration="durationCollapse"
            >
                <div
                    v-show="sending && showPreloader"
                    :class="{ 'box-body': sending }"
                >
                    <img
                        alt="Preloader"
                        class="table-preloader"
                        src="img/preloader.png"
                    />
                </div>
                <div
                    v-if="report === null && !showPreloader"
                    class="box-body"
                >
                    <p v-if="!showError">No results found.</p>
                    <p v-else>Error occurred on the server side</p>
                </div>
                <div
                    v-if="report !== null && !showPreloader"
                    class="box-body table-responsive no-padding"
                >
                    <non-clicker-report-table :report="report" />
                </div>
            </vue-slide-up-down>
        </div>
    </div>
</template>

<script>
import NonClickerReportTable from './NonClickerReportTableComponent';

export default {
    components: {
        NonClickerReportTable,
    },
    props: {
        idTab: String,
        count: Number,
        dataItems: Array,
        disabledDynamicFilter: Boolean,
        externalParams: Object,
    },
    data: function () {
        return {
            onlyActive: this.getExternalParam('onlyActive', true),
            collapse: {
                filter: true,
                report: true,
            },
            durationCollapse: 700,
            report: null,
            sending: false,
            showPreloader: false,
            showError: false,
            existFilter: false,
            itemsFilterSelected: [],
            formItems: [
                { id: 'filter', type: 'static' },
                { id: 'onlyActive', type: 'static' },
                { id: 'contacts_list', type: 'dynamic' },
                { id: 'contacts_list_tag', type: 'dynamic' },
                { id: 'contacts_list_category', type: 'dynamic' },
            ],
            itemsFilter: [
                {
                    name: 'Contacts Lists',
                    id: 'contacts_list',
                    route: '/non-clicker-report/get-filter-list?entity=contacts_list',
                    classMainBlock: 'form-group col-lg-4 col-md-6 col-xs-12',
                    classSelect: 'form-control',
                    change: 'changeFilterDefault',
                    max: null,
                    disableByPhoneNumber: false,
                },
                {
                    name: 'Contacts Lists Tag',
                    id: 'contacts_list_tag',
                    route: '/non-clicker-report/get-filter-list?entity=contacts_list_tag',
                    classMainBlock: 'form-group col-lg-4 col-md-6 col-xs-12',
                    classSelect: 'form-control',
                    change: 'changeFilterDefault',
                    max: null,
                    disableByPhoneNumber: false,
                },
                {
                    name: 'Contacts List Category',
                    id: 'contacts_list_category',
                    route: '/non-clicker-report/get-filter-list?entity=contacts_list_category',
                    classMainBlock: 'form-group col-lg-4 col-md-6 col-xs-12',
                    classSelect: 'form-control',
                    change: 'changeFilterDefault',
                    max: null,
                    disableByPhoneNumber: false,
                },
            ],
        };
    },
    mounted() {
        this.count > 1 && this.changeFilterParameter();
        this.externalParams && this.externalParams['filter'] && this.externalParams['filter'].length > 0 ? (this.sending = true) : this.checkDynamicFilters();
    },
    methods: {
        getExternalParam(key, defaultParam) {
            return this.externalParams && this.externalParams[key] !== undefined ? this.externalParams[key] : defaultParam ? defaultParam : null;
        },
        callMethod(key) {
            this[key]();
        },
        getReport(exportReport) {
            let self = this;
            let mainFilter = '';
            let unnecessarySendKeys = ['filter', 'onlyActive'];

            self.formItems.forEach(function (value) {
                if (unnecessarySendKeys.some((el) => el === value.id)) {
                    return;
                }
                let currentRef = self.getCurrentRef(value.id);
                if (currentRef) {
                    let valueRef = currentRef.getValue();
                    valueRef = self.changeEmptyObject(valueRef);
                    if (valueRef) {
                        mainFilter += mainFilter.length === 0 ? '?' : '&';
                        mainFilter += self.addGetParam(value.id, valueRef);
                    }
                }
            });

            exportReport ? self.eventExportReport(mainFilter) : self.eventGetReport(mainFilter);
        },
        eventExportReport(mainFilter) {
            let link = document.createElement('a');
            document.body.appendChild(link);
            link.href = '/non-clicker-report/export' + mainFilter;
            link.click();
            link.remove();
        },
        changeEmptyObject(value) {
            return typeof value === 'object' && value !== null && Object.keys(value).length === 0 ? null : value;
        },
        eventGetReport(mainFilter) {
            let self = this;
            self.showPreloader = true;
            self.showError = false;
            self.$emit('sendForm', true);

            // Get data by filter
            axios
                .get('/non-clicker-report/get' + mainFilter)
                .then((response) => {
                    self.report = response.data.result;
                    if (self.report.items !== null) {
                        self.report.items = Object.values(self.report.items);
                    }
                    self.report = self.report.items === null && self.report.totals === null ? null : self.report;

                    // Hide preloader
                    self.showPreloader = false;
                    self.$emit('sendForm', false);
                })
                .catch(() => {
                    this.report = null;
                    self.showPreloader = false;
                    self.showError = true;
                    this.$emit('sendForm', false);
                });
        },
        addGetParam(key, value) {
            let params = '';
            if (key === 'clearCache') {
                params += key + '=' + Number(value);
            } else {
                params += key + '=' + value;
            }

            return params;
        },
        clearFilter() {
            let self = this;
            this.formItems.forEach(function (value) {
                let itemRef = self.getCurrentRef(value.id);
                if (itemRef) {
                    itemRef.clear();
                    self.externalParams && self.externalParams[value.id] && (self.externalParams[value.id] = null);
                }
            });

            this.itemsFilterSelected = [];
            self.report = null;
            self.existFilter = false;
            self.changeFilterParameter();
        },
        changeOnlyActive(data) {
            this.onlyActive = data;
            this.filterOnlyActive();
            this.changeFilterParameter();
        },
        filterOnlyActive() {
            let self = this;

            if (self.$refs['formItemsDynamicRef']) {
                self.$refs['formItemsDynamicRef'].forEach(function (value) {
                    let currentItems = self.dataItems[value.id] || [];
                    if (self.onlyActive) {
                        // Filter items
                        value.itemsData = currentItems.filter((el) => el.active === undefined || el.active === true);

                        // Filter selected items
                        let itemValues = value.getValue();
                        let filteredValue = itemValues && value.itemsData ? value.itemsData.filter((value) => itemValues.indexOf(value.id) !== -1).map((value) => value.id) : null;

                        // Set selected items
                        value.setModelAndValue(filteredValue);
                    } else {
                        value.itemsData = currentItems;
                    }
                });
            }
        },
        changeFilter(data) {
            this.itemsFilterSelected = this.itemsFilter.filter((value) => data.indexOf(value.id) !== -1);
            this.existFilter = data && data.length > 0;
            this.cleanDynamicItems();
            this.filterOnlyActive();
            this.changeFilterParameter();
        },
        changeFilterDefault() {
            this.changeFilterParameter();
        },
        getItems(id) {
            return this.dataItems[id];
        },
        setItems(data, id) {
            this.$emit('setMainItems', data, id);
            this.checkDynamicFilters();
        },
        checkDynamicFilters() {
            let self = this;
            let allDataLoaded = true;
            self.itemsFilterSelected.forEach(function (item) {
                if (!self.dataItems[item.id]) {
                    allDataLoaded = false;
                }
            });

            this.filterOnlyActive();
            this.$emit('setDisabledDynamicFilter', !allDataLoaded);
        },
        getCurrentRef(key) {
            let currentRef = null;
            let currentItem = this.formItems.find(function (currentValue) {
                return key === currentValue.id;
            });
            if (currentItem.type === 'static') {
                let keyString = key + 'Ref';
                currentRef = this.$refs[keyString] ? this.$refs[keyString] : null;
            } else {
                let keyString = 'formItemsDynamicRef';
                currentRef = this.$refs[keyString] && this.$refs[keyString].length > 0 ? this.getDynamicRef(this.$refs[keyString], key) : null;
            }

            return currentRef;
        },
        getDynamicRef(refs, key) {
            let currentRef = refs.find(function (currentValue) {
                return key === currentValue.id;
            });
            return currentRef ? currentRef : null;
        },
        cleanDynamicItems() {
            let self = this;
            self.formItems.forEach(function (value) {
                if (value.type === 'dynamic') {
                    let currentRef = self.getCurrentRef(value.id);
                    let existFilter = self.itemsFilterSelected.filter((valueSelect) => valueSelect.id === value.id).length > 0;
                    if (currentRef && !existFilter) {
                        currentRef.clear();
                        self.externalParams && self.externalParams[value.id] && (self.externalParams[value.id] = null);
                    }
                }
            });
        },
        getDynamicId(id) {
            return this.idTab + '_' + id;
        },
        toggleCollapse(type) {
            this.collapse[type] = !this.collapse[type];
        },
        getCollapseStatus(type) {
            return this.collapse[type];
        },
        changeFilterParameter() {
            this.$emit('changeFilterParameter');
        },
    },
};
</script>
